module.exports = __webpack_public_path__ + "static/media/superheavy.3a3aaab2.jpg";